import getWindowHeight from './get-window-height';
import isBrowser from './is-browser';

export default function isScrolledIntoView(element) {
  if (!isBrowser) {
    return false;
  }

  const elementTop = element.getBoundingClientRect().top;
  const elementBottom = element.getBoundingClientRect().bottom;
  return elementTop <= getWindowHeight() && elementBottom >= 0;
}
